import Head from "next/head";
import PageBreadcrumb from "../../components/PageBreadcrumb";
import SessionDashboard from "../../components/Dashboard/SessionDashboard";

const SessionDashboardPage = () => (
  <>
    <Head>
      <title>Sessions Dashboard</title>
    </Head>
    <PageBreadcrumb
      routes={[
        { name: "Sessions", pathname: "/dashboard/activities" },
        { name: "Dashboard", pathname: "/dashboard/activities" },
      ]}
    />
    <SessionDashboard />
  </>
);

export default SessionDashboardPage;
